import styled from 'styled-components';
import { Section } from '@elfsight/lib-stripe-integration';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { Divider } from './divider';

const COMPONENT_NAME = 'footer';

export interface FooterProps {
  textColor: string;
  text: string;
  withoutTopPadding?: boolean;
}

export function Footer({
  textColor,
  text,
  withoutTopPadding = false
}: FooterProps) {
  return (
    <FooterContainer>
      <Section
        className={createReadableClass({
          component: COMPONENT_NAME,
          element: 'divider-wrapper'
        })}
        $withoutTopPadding={withoutTopPadding}
        $withoutBottomPadding
      >
        <Divider />
      </Section>
      <FooterText
        textToken="text14"
        color={getColorWithAlpha(textColor, 0.5)}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </FooterContainer>
  );
}

const FooterContainer = styled.div.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME
  })
})`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 100%;
`;

const FooterText = styled(Typography).attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'text'
  })
})`
  width: 100%;
  margin: 0;

  white-space: pre-wrap;

  & a {
    color: inherit;

    text-decoration: underline;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    cursor: pointer;
  }
`;
